import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  Home,
  Lightbulb,
  BarChart2,
  Settings,
  HelpCircle,
  LogOut,
  FileText,
  Calendar,
  Zap,
  CreditCard
} from 'lucide-react';

const menuItems = [
  { icon: Home, label: 'Início', path: '/dashboard' },
  { icon: Lightbulb, label: 'Ideias de Conteúdo', path: '/dashboard/ideias' },
  { icon: Calendar, label: 'Calendário', path: '/dashboard/calendario' },
  { icon: BarChart2, label: 'Análises', path: '/dashboard/analises' },
  { icon: FileText, label: 'Meus Planos', path: '/dashboard/planos' },
  { icon: CreditCard, label: 'Preços', path: '/dashboard/precos' },
  { icon: Settings, label: 'Configurações', path: '/dashboard/configuracoes' },
  { icon: HelpCircle, label: 'Ajuda', path: '/dashboard/ajuda' }
];

export default function Sidebar() {
  const location = useLocation();
  const { logout } = useAuth();

  return (
    <aside className="h-full flex flex-col bg-white">
      {/* Logo */}
      <div className="p-6 border-b">
        <Link to="/" className="flex items-center space-x-2">
          <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center">
            <Zap className="h-5 w-5 text-primary-600" />
          </div>
          <span className="text-xl font-semibold text-gray-900">Kontty</span>
        </Link>
      </div>

      {/* Navigation */}
      <nav className="flex-1 py-6">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center px-6 py-3 space-x-3 ${
                isActive
                  ? 'bg-primary-50 text-primary-600'
                  : 'text-gray-600 hover:bg-gray-50'
              }`}
            >
              <Icon className="h-5 w-5" />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>

      {/* Logout Button */}
      <div className="p-6 border-t">
        <button
          onClick={logout}
          className="flex items-center space-x-3 text-gray-600 hover:text-gray-900 w-full"
        >
          <LogOut className="h-5 w-5" />
          <span>Sair</span>
        </button>
      </div>
    </aside>
  );
}